// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * RecoveryKeyInput Component Styles
 */

.recovery-key-input-wrapper {
  position: relative;
  width: 600px;
  margin: 0 auto;
}

.recovery-key-input {
  width: 600px;
  padding: 10px;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 16px;
  letter-spacing: 0.5px;
  line-height: 1.5;
  border: 2px solid #979797;
  border-radius: 8px;
  background-color: #fff;
  color: #333;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  outline: none;
}

.recovery-key-input:hover:not(:disabled) {
  border-color: #666;
}

.recovery-key-input:focus:not(:disabled) {
  border-color: #DE4858;
  box-shadow: 0 0 0 3px rgba(222, 72, 88, 0.1);
}

.recovery-key-input:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
  opacity: 0.7;
}

.recovery-key-input.recovery-key-input-invalid {
  border-color: #dc3545;
}

.recovery-key-input.recovery-key-input-invalid:focus {
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.recovery-key-input::placeholder {
  color: #979797;
  font-size: 16px;
  font-family: 'SF Pro Display', -apple-system, sans-serif;
  letter-spacing: normal;
}

.recovery-key-input-status {
  display: none;
}

.recovery-key-char-count {
  font-weight: 500;
}

.recovery-key-valid-icon {
  color: #28a745;
  font-size: 18px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Dark theme support */
@media (prefers-color-scheme: dark) {
  .recovery-key-input {
    background-color: #1a1a1a;
    border-color: #444;
    color: #e0e0e0;
  }

  .recovery-key-input:hover:not(:disabled) {
    border-color: #666;
  }

  .recovery-key-input:focus:not(:disabled) {
    border-color: #0d6efd;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.2);
  }

  .recovery-key-input:disabled {
    background-color: #0d0d0d;
    color: #666;
  }

  .recovery-key-input::placeholder {
    color: #666;
  }

  .recovery-key-input-status {
    color: #999;
  }

  .recovery-key-valid-icon {
    color: #5cb85c;
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .recovery-key-input {
    border-width: 3px;
  }

  .recovery-key-input:focus:not(:disabled) {
    outline: 3px solid;
    outline-offset: 2px;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .recovery-key-input {
    transition: none;
  }

  .recovery-key-valid-icon {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Recovery/RecoveryKeyInput.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,wDAAwD;EACxD,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,6CAA6C;EAC/C;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/**\n * RecoveryKeyInput Component Styles\n */\n\n.recovery-key-input-wrapper {\n  position: relative;\n  width: 600px;\n  margin: 0 auto;\n}\n\n.recovery-key-input {\n  width: 600px;\n  padding: 10px;\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 16px;\n  letter-spacing: 0.5px;\n  line-height: 1.5;\n  border: 2px solid #979797;\n  border-radius: 8px;\n  background-color: #fff;\n  color: #333;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  outline: none;\n}\n\n.recovery-key-input:hover:not(:disabled) {\n  border-color: #666;\n}\n\n.recovery-key-input:focus:not(:disabled) {\n  border-color: #DE4858;\n  box-shadow: 0 0 0 3px rgba(222, 72, 88, 0.1);\n}\n\n.recovery-key-input:disabled {\n  background-color: #f5f5f5;\n  color: #999;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.recovery-key-input.recovery-key-input-invalid {\n  border-color: #dc3545;\n}\n\n.recovery-key-input.recovery-key-input-invalid:focus {\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n}\n\n.recovery-key-input::placeholder {\n  color: #979797;\n  font-size: 16px;\n  font-family: 'SF Pro Display', -apple-system, sans-serif;\n  letter-spacing: normal;\n}\n\n.recovery-key-input-status {\n  display: none;\n}\n\n.recovery-key-char-count {\n  font-weight: 500;\n}\n\n.recovery-key-valid-icon {\n  color: #28a745;\n  font-size: 18px;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Dark theme support */\n@media (prefers-color-scheme: dark) {\n  .recovery-key-input {\n    background-color: #1a1a1a;\n    border-color: #444;\n    color: #e0e0e0;\n  }\n\n  .recovery-key-input:hover:not(:disabled) {\n    border-color: #666;\n  }\n\n  .recovery-key-input:focus:not(:disabled) {\n    border-color: #0d6efd;\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.2);\n  }\n\n  .recovery-key-input:disabled {\n    background-color: #0d0d0d;\n    color: #666;\n  }\n\n  .recovery-key-input::placeholder {\n    color: #666;\n  }\n\n  .recovery-key-input-status {\n    color: #999;\n  }\n\n  .recovery-key-valid-icon {\n    color: #5cb85c;\n  }\n}\n\n/* High contrast mode */\n@media (prefers-contrast: high) {\n  .recovery-key-input {\n    border-width: 3px;\n  }\n\n  .recovery-key-input:focus:not(:disabled) {\n    outline: 3px solid;\n    outline-offset: 2px;\n  }\n}\n\n/* Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .recovery-key-input {\n    transition: none;\n  }\n\n  .recovery-key-valid-icon {\n    animation: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
